export default __webpack_public_path__ + "static/media/screen_3.6fdc0eff.png";